import React from 'react';
import { ConnectedRouter } from 'connected-react-router';

export default function Router(props: any) {
  return <ConnectedRouter {...props} />;
}
